export {
  // ts-prune-ignore-next-line
  locationCookieName,
  // ts-prune-ignore-next-line
  locationCookieMaxAge,
  // ts-prune-ignore-next-line
  cloudFrontCountryHeaderName,
  // ts-prune-ignore-next-line
  cloudFlareCountryHeaderName,
} from './location';
export { utmTagsCookieMaxAgeSeconds } from './utmTags';
